import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import BrandStory from "@/components/landing/BrandStory";
import ProjectOverview from "@/components/landing/ProjectOverview";
import LocationHeritage from "@/components/landing/LocationHeritage";
import LivingInvestment from "@/components/landing/LivingInvestment";
import Gallery from "@/components/landing/Gallery";
import LaunchBanner from "@/components/landing/LaunchBanner";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";
import LaunchPopup from "@/components/landing/LaunchPopup";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#FAF7F3] min-h-screen">
      <Navbar />
      <Hero />
      <BrandStory />
      <ProjectOverview />
      <LocationHeritage />
      <LivingInvestment />
      <Gallery />
      <LaunchBanner />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
      <LaunchPopup />
    </div>
  );
}
